import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { Search } from "lucide-react";
import { useGetMyFeatures } from "@tubo/api-models/hooks/tenant-feature-api.hooks";
import { Button } from "@tubo/ui/components/ui/button";

export const Route = createFileRoute("/_app/semantic-platform/knowledge-debug")({
  component: KnowledgeDebugLayout,
});

/**
 * 知识服务调试路由级 Feature 门禁(波次5 5A-1;structuredKnowledge 总闸)
 *
 * 布局对齐 concepts/route.tsx 模式;调试页为 KS-03 调试入口,不进生产 chat。
 */
function KnowledgeDebugLayout() {
  const navigate = useNavigate();
  const { data: features, isLoading } = useGetMyFeatures({ query: {} });

  if (isLoading) {
    return <div className="flex h-full items-center justify-center text-muted-foreground">加载中…</div>;
  }

  if (!features?.structuredKnowledge) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        <div className="text-center">
          <Search className="mx-auto mb-3 h-12 w-12 text-icon-secondary-muted" />
          <p className="text-sm font-medium">知识服务(调试)</p>
          <p className="mt-1 text-xs text-muted-foreground/70">该功能尚未对当前租户开放(structuredKnowledge)</p>
          {/* 直链进入时浏览器历史可能是空/站外，返回固定落知识本体域首页 */}
          <Button variant="outline" size="sm" className="mt-4" onClick={() => navigate({ to: "/semantic-platform" })}>
            返回
          </Button>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
